import {
    _getStartStyle,
    _getElStyle,
    goMaxLengthLabel,
    _showClearIcon,
    _getInputElStyle,
    getInputWid,
    goClearInputIcon,
    _removeValidationInfo,
    _hideClearIcon
} from "./Common_Fun";
import {AssertUtils} from "goingutils";

let TextAreaCtrl = {
    /**
     * 获取控件的html
     * @param formType 表单类型 分查询表单 和普通表单
     * @param item 选项
     * @param targetObj 可能是GoingForm对象 也可能是QueryForm对象
     */
    getHtml: function (formType, item, targetObj) {
        if (formType === "query") {
            return TextAreaCtrl.getEditorHtml(item, targetObj);
        } else if (formType === "singleQuery") {
            return this.getSingleQueryHtml(item, targetObj);
        } else {
            return TextAreaCtrl.getEditorHtml(item, targetObj);
        }
    },
    /**
     * 获取但条件查询下的html代码
     * @param item
     * @param targetObj
     * @returns {string}
     */
    getSingleQueryHtml: function (
        {label, id, required, defVal = ""},
        targetObj
    ) {
        return ` <input class="search-ipt pull-left" type="text" id="${
            targetObj.prefixCls
            }_${id}">`;
    },
    //获取显示值
    getShowValue(curVal) {
        return curVal;
    },
    /**
     * 获取编辑模式下的html代码
     * @param item
     * @param targetObj
     * @returns {string}
     */
    getEditorHtml: function (
        {label, id, required, maxlength = 100, labelWidth = "md", width,inputWidth = "auto"},
        targetObj
    ) {
        return `<div class="row  go-form-row flex-div" style="margin-top: 3px;">
                <div class="go-label" style="${_getElStyle(targetObj)}">
                <span class="start-require" ${_getStartStyle({required},targetObj)}>*</span>${label}：</div> 
                <div class="go-content ${getInputWid(inputWidth)} text-area-ctl">
                     <textArea style="${_getInputElStyle(targetObj)}" maxlength="${maxlength}" id="${targetObj.prefixCls}_${id}" type="text" 
                     class="form-control go-text-area padding-l-bs"></textArea>
                     ${goClearInputIcon(targetObj, id)} 
                     ${goMaxLengthLabel(targetObj, id, 0, maxlength,inputWidth)}
                </div></div>`;
    },
    /**
     * 初始化提交数据
     * @param item
     * @param targetObj 目标form对象
     * @param backJson 返回的数据
     * @param formType 表单类型
     */
    getSubmitData: function (
        item,
        targetObj,
        backJson,
        formType
    ) {
        if (formType === "query") {
            this.getQuerySubmitData(item, targetObj, backJson);
        } else {
            this.getEditorSubmitData(item, targetObj, backJson);
        }
    },
    clearData(item, formType, targetObj) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        $("#" + inputElId).val("");
    },
    setValue(prop, propValue, item, targetObj) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        $("#" + inputElId).val(propValue);
        if (AssertUtils.isNotEmpty(propValue)) {
            _showClearIcon(inputElId);
        }
    },
    getQuerySubmitData: function (item, targetObj, backJson) {
        this.getEditorSubmitData(item, targetObj, backJson);
    },
    getRealValue(value) {
        return value || " ";
    },
    getEditorSubmitData: function (item, targetObj, backJson) {
        //时间
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        backJson[item["id"]] = $("#" + inputElId).val();
    },
    initCtlEvent: function (parentObj) {
        $(parentObj)
            .find(".go-text-area")
            .on("input propertychange", function () {
                let $this = $(this),
                    _val = $this.val(),
                    count = "";
                let elId = $(this).attr("id");
                let maxlength = parseInt($(this).attr("maxlength") + "");
                //输入长度提醒消息
                if (_val.length > maxlength) {
                    $this.val(_val.substring(0, maxlength));
                }
                count = maxlength - ($this.val() + "").length;
                $(`#${elId}_count`).text(count + "/" + maxlength);


                //如果输入不为空 则显示清空图标  负责隐藏图标
                if (($this.val() + "").length > 0) {
                    _removeValidationInfo($(this).attr("id"));
                    _showClearIcon($(this).attr("id"));
                } else {
                    _hideClearIcon($(this).attr("id"));
                }
            }).each(function () {
                let elId = $(this).attr("id");
                $(this).mouseover(function () {
                    let elVal = $(`#${elId}`).val();
                    if (AssertUtils.isNotEmpty(elVal)) {
                        _showClearIcon(elId, parentObj);
                    }
                }).mouseleave(function () {
                    _hideClearIcon(elId);
                });
            });

    }
};

export default TextAreaCtrl;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goForm/components/js-textArea.js